export const CITATION_FORM = 'citation-form'
export const CITATION_FORM_COMPLETE_BUTTON = 'form-next-button'
export const CITATION_FORM_BACK_BUTTON = 'citation-button-button'
export const CITATION_FORM_UPDATE_BUTTON = 'citation-update-button'
